interface Props {
  color?: string
}

export const SingleFile = ({ color = 'currentColor' }: Props) => {
  return (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="file">
        <path
          id="Icon"
          d="M18.6042 4.625V10.8125C18.6042 11.6668 19.3224 12.3594 20.2083 12.3594H26.625M18.8794 4.625H10.5833C8.81142 4.625 7.375 6.01012 7.375 7.71875V26.2812C7.375 27.9899 8.81142 29.375 10.5833 29.375H23.4167C25.1886 29.375 26.625 27.9899 26.625 26.2812V12.094C26.625 11.2735 26.287 10.4866 25.6853 9.90636L21.148 5.53114C20.5464 4.95095 19.7303 4.625 18.8794 4.625Z"
          stroke={color}
          strokeOpacity="0.8"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  )
}
